import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { VitaminDSupplementPeptideComponent } from '@consultation-upsells/vitamin-d-supplement/peptide/vitamin-d-supplement-peptide.component';
import { VitaminDSupplementRashComponent } from '@consultation-upsells/vitamin-d-supplement/rash/vitamin-d-supplement-rash.component';
import { VitaminDSupplementComponent } from '@consultation-upsells/vitamin-d-supplement/vitamin-d-supplement.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Vitamin D Supplement upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-vitamin-d-supplement-switcher',
  standalone: true,
  imports: [
    CommonModule,
    VitaminDSupplementComponent,
    VitaminDSupplementPeptideComponent,
    VitaminDSupplementRashComponent,
  ],
  templateUrl: './vitamin-d-supplement-switcher.component.html',
})
export class VitaminDSupplementSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
